import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { useSnackbar } from 'contexts/snackbar';
import { omit } from 'lodash';
import { createContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import batchService from 'services/batch';
import { v4 as uuid } from 'uuid';

const PageContext = createContext();

const PageProvider = (props) => {
    const { course, currentAssignmentId, currentAssignment, setBatch, formative, studentSubmissions } = useApp();
    const { auth } = useAuth();
    const history = useHistory();
    const { message } = useSnackbar();

    const [uploadSubmissionDialog, setUploadSubmissionDialog] = useState({ open: false });
    const [editFormativeDialog, setEditFormativeDialog] = useState({ open: false });
    const [viewFormativeDialog, setViewFormativeDialog] = useState({ open: false, submissionId: '' });

    const onClickBack = () => {
        history.push(`/assignments/${currentAssignmentId}`);
    };

    const onClickUpload = () => {
        setUploadSubmissionDialog({ open: true });
    };

    const onClickCancel = () => {
        message.error('Not Implemented.');
    };

    const onClickViewSubmission = (submissionId) => {
        history.push(`/assignments/${currentAssignmentId}/submissions/${submissionId}`);
    };

    const createSubmissions = async (submissions) => {
        const timestamp = new Date().getTime();
        const id = uuid();
        const batch = {
            id,
            active: true,
            created_on: timestamp,
            modified_on: timestamp,
            owner_account_id: auth.id,
            course_id: course.id,
            assignment_id: currentAssignment.id,
            submissions,
            is_finished: false,
            type: 'formative',
            previous_submission_ids: (studentSubmissions ?? [])
                .sort((a, b) => a.created_on - b.created_on)
                .map((submission) => submission.id),
            formative_snapshot: omit(formative, ['_id']),
        };
        setBatch((current) => [...(current || []), batch]);
        try {
            await batchService.createSubmissions(batch);
        } catch (e) {
            console.error(e);
        }
    };

    const onClickViewFormative = (submissionId) => {
        setViewFormativeDialog({ open: true, submissionId });
    };

    const onClickEditFormative = () => {
        setEditFormativeDialog({ open: true });
    };

    return (
        <PageContext.Provider
            value={{
                currentAssignment,
                uploadSubmissionDialog,
                setUploadSubmissionDialog,
                editFormativeDialog,
                setEditFormativeDialog,
                viewFormativeDialog,
                setViewFormativeDialog,

                onClickBack,
                onClickUpload,
                onClickCancel,
                onClickViewSubmission,
                createSubmissions,
                onClickViewFormative,
                onClickEditFormative,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
